module.exports = __webpack_public_path__ + "static/img/enviroPoly-recycled-plastic-sign.4c6b32a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/routed-plastic/enviroPoly-recycled-plastic-sign.jpg
// module id = 692
// module chunks = 0